var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-text-counter",class:{ "text-danger": _vm.remaining === 0 }},[(_vm.remaining === _vm.limit)?[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('counter.characters', { count: _vm.remaining })))])]:[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('counter.remainingCharacters', { count: _vm.remaining })))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }